$(document).foundation();

$(document).ajaxComplete(function () {
    $(document).foundation();
});

$(document ).ready(function() {
    if($("header-lang-select-span:contians('DE')")) {
        $('body').addClass('body-de'); 
    }    
    if ( $(window).width() <= 1023 ) {
        $('div').removeClass('filter-span-title');
    }
     
});

$('.form__label').find('input').each(function(){
    if($(this).prop('required')){
        $(this).parent('.form__label').find('.form__label-title').append('<span> *</span>');
    } 
});

// $('.product-left-buttons .button-question').on('click', function(){
//     $('body').addClass('fancy-lock-on');
// });

// $(document).on('click', '.fancybox-overlay', function () {
//     console.log('hoi');
// });

// $(document).on('click', '.fancybox-close', function () {
//     $('body').removeClass('fancy-lock-on');
// });


$(function(){

 
    $('.tooltip-block').hover(
        function(){$(this).toggleClass('tooltip-block-hover');
    });
    /*
    if ($('#map_search').length > 0){
        $('body').on('keyup', '#map_search', function(e){
            if (e.which == 13){
                alert('onkapodt');
                e.preventDefault();
                e.stopPropagation();
            }
            return false;
        });
    }*/

    $( window ).resize(function() {
        $('.match-height').matchHeight();
    });

    $( document ).ajaxComplete(function() {
        $('.match-height').matchHeight();
    });

    $(function() {
        $('.match-height').matchHeight();
    });

    // $("body").on("click", "#form-verkooppunten .filter-select1 input", function () {
    //      $("#form-verkooppunten").addClass('filter-select1-active');
    //      $("#form-verkooppunten").removeClass('filter-select2-active');
    //      $("#form-verkooppunten .filter-select2 select").attr("disabled", true);
    //
    // });
    //
    // $("body").on("click", "#form-verkooppunten .filter-select1 select", function () {
    //      $("#form-verkooppunten").addClass('filter-select1-active');
    //      $("#form-verkooppunten").removeClass('filter-select2-active');
    //      $("#form-verkooppunten .filter-select2 select").attr("disabled", true);
    // });
    //
    // $("body").on("click", "#form-verkooppunten .filter-select2 select", function () {
    //      $("#form-verkooppunten").addClass('filter-select2-active');
    //      $("#form-verkooppunten").removeClass('filter-select1-active');
    //      $("#form-verkooppunten .filter-select1 select").attr("disabled", true);
    //      $("#form-verkooppunten .filter-select1 input").attr("disabled", true);
    // });

/*
  $('.flexslider_bottom').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 155,
    itemMargin: 5,
    asNavFor: '.flexslider_top'
  });

  $('.flexslider_top').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    sync: ".flexslider_bottom"
  });
 */
});

jQuery(document).ready(function() {
    jQuery('.timeline-item:even').addClass("").viewportChecker({
        classToAdd: 'timeline-animation animated bounceInLeft',
        offset: 240
    });
    jQuery('.timeline-item:odd').addClass("").viewportChecker({
        classToAdd: 'timeline-animation animated bounceInRight',
        offset: 240
    });
});


$(function () {

    if ($('.link-block').length > 0)
    {
        var stickyTop = $('.link-block').offset().top;
        $(window).on( 'scroll', function(){
            if ($(window).scrollTop() >= stickyTop - 109) {
                $('body').addClass('orange-fixed');
            } else {
                $('body').removeClass('orange-fixed');
            }
        });
    }

    $('.impressie-homepage .impressie-block a img').each(function() {
        var imgSrc = $(this).attr('src');
        $(this).parent().css({'background-image': 'url('+imgSrc+')'});
        $(this).remove();
    });



    $('.video-homepage').lightGallery({
        download: false,
        youtubePlayerParams: { modestbranding: 0, rel: 0, showinfo: 0, controls: 1 }
    });

     $('#video-gallery').lightGallery({
        download: false,
        youtubePlayerParams: { modestbranding: 0, rel: 0, showinfo: 0, controls: 1 }
    });

    /*
    $('.product-item__left li').lightGallery({
        download: false,
        youtubePlayerParams: { modestbranding: 0, rel: 0, showinfo: 0, controls: 1 },
        thumbnail:true,
        animateThumb: true,
    });
    */

    $('.row-content-img').lightGallery({
        download: false,
        thumbnail:true,
        animateThumb: true,
    });

    /*
    $('.product-right-images ul li').lightGallery({
        download: false,
        thumbnail:true,
        animateThumb: false,
        showThumbByDefault: false
    });
    */

    // $('.product-left-inner').readmore({
    //     speed: 1000,
    //     collapsedHeight: 350,
    //     moreLink: '<a href="#" class="button button-moreless">'+LANG_LEES_MEER+' <i class="fa fa-angle-down" aria-hidden="true"></i></a>',
    //     lessLink: '<a href="#" class="button button-moreless">'+LANG_LEES_MINDER+' <i class="fa fa-angle-up" aria-hidden="true"></i></a>',
    //     afterToggle: function(trigger, element, expanded) {
    //         $('.product-left-inner').toggleClass("product-left-inner-open");
    //     }
    // });

    if ( $( "a" ).is( ".button-moreless" ) ) {
        $( ".product-left-inner" ).append( "<div class='product-left-inner-bottom'></div>" );
    }


    $('.impressie-homepage .impressie-block a img').each(function() {
        var imgSrc = $(this).attr('src');
        $(this).parent().css({'background-image': 'url('+imgSrc+')'});
        $(this).remove();
    });

    $( ".kern-inner ul li" ).prepend( "<i class='fa fa-check-circle' aria-hidden='true'></i>" );

    $('.header-search > a').on({
        click: function (){
            $('body').toggleClass('header-search-open');
        }
    });
    $('.header-lang-select').on({
        click: function (){
            $(this).parent().toggleClass('header-lang-open');
        }
    });

    $(".faq__item__btn").click(function () {
        $(this).parent().find('.faq__item__answer').toggleClass("faq__item__answer--open");
        $(this).toggleClass("faq__item__btn--open");
    });

    $('.theiaStickySidebar').theiaStickySidebar({
        additionalMarginTop: 180
    });

    $(".fdatepicker").fdatepicker({
        language: 'nl',
        format: 'dd-mm-yyyy'
    });

    $(".disable-scroll").click(function () {
        $('.disable-scroll').fadeOut();
    });

    $(".current-language").click(function () {
        $('.language-layer').fadeToggle();
    });

    // hide #back-top first
    $("#back-totop").hide();

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('#back-totop').fadeIn();
        } else {
            $('#back-totop').fadeOut();
        }
    });

    // scroll body to 0px on click
    $('#back-totop').click(function () {
        $('body,html').animate({scrollTop: 0}, 800);
        return false;
    });

    $('.fancybox').fancybox({
        beforeLoad: function (data) {
            $('.debugmsgs').remove();
        },
        helpers: {
            overlay: {
                locked: false
            }
        }
    });

    $('.content-fancybox-gallery .fancybox').each(function () {
        $(this).attr('data-fancybox-group', 'data-fancybox-group');
    });

    $('.fancybox-ajax').fancybox({
        type: 'ajax',
        maxWidth: 800,
        beforeLoad: function (data) {
            $('.debugmsgs').remove();
        }
    });

    $('.fancybox-iframe2').fancybox({
        'type': 'iframe',
        'titleShow': false,
        'transitionIn': 'elastic',
        'transitionOut': 'elastic',
        'padding': 0,
        'maxWidth': 800,
        'maxHeight': 450,
        'fitToView': true,
        'autoScale': true
    });


    ajaxFilter();

    // popup warning
    $(".warning__close").click(function () {
        $(".warning").css("display","none");
    });
});

function ajaxFilter()
{
    $('.ajax-filter').each(function(){
        var form = $(this);
        form.append('<input type="hidden" name="action" value="Filter" />');
        form.append('<input type="hidden" name="koppel" value="' + form.attr('data-koppel') + '" />');
        $(this).find(':input[type="checkbox"]').change(function(){
            $.fancybox.showLoading();
            $.ajax({
                url: window.location.href,
                data: form.serialize(),
                type: 'post',
                success: function(data)
                {
                    $('.ajax-filter').replaceWith(data);
                    new Foundation.Accordion($('.accordion'));
                    $.fancybox.hideLoading();
                    ajaxFilter();
                }
            });
        })
    });
} 


$('.partner-slider').owlCarousel({
	loop:true,
	margin:40,
	nav:false,
	navText:[
		"<i class='fa fa-angle-left'></i>",
		"<i class='fa fa-angle-right'></i>"
	],
	responsive:{
		0:{
		items:1
		},
		375:{
		items:2
		},
		600:{
		items:3
		},
		800:{
		items:4
		},
		1150:{
		items:5
		}
	}
});




$(function () {
    $('.lightslidergallery').lightSlider({
        gallery: true,
        item: 1,
        loop: true,
        thumbItem: 4,
        speed: 1000,
        slideMargin: 0,
        pause: 4000,
        auto: true,
        pauseOnHover: false,
        enableDrag: false,
        thumbMargin: 20,
        galleryMargin: 20,
        currentPagerPosition: 'left',
        onSliderLoad: function (el) {
            if(el != undefined) {
                el.lightGallery({
                    selector: '.lightslidergallery .lslide'
                });
            }
        }
    });
});
